import _toNumber from 'lodash/toNumber';
import _toString from 'lodash/toString';
import * as R from 'ramda';
export const coerce = R.curry((type, value) => R.cond([
    [R.always(R.equals(type, 'Number')), _toNumber],
    [R.always(R.equals(type, 'String')), _toString],
    [
        R.always(R.equals(type, 'Boolean')),
        R.ifElse(R.equals('false'), R.F, Boolean),
    ],
    [R.T, R.identity],
])(value));
export default coerce;
